import React, { useState, useEffect, useCallback, useRef } from "react";
import { Input } from "reactstrap";
import debounce from "lodash.debounce";
import axios from "axios";
import UserSuggestionsDropdown from "./UserSuggestionsDropdown";

const AutocompleteInput = ({
  value,
  onChange,
  onSelect,
  placeholder,
  searchUrl, // e.g., `/organization/${orgId}/program/${progId}/user`
  params = {},
  field, // 'email', 'first_name', etc.
  ...rest
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const containerRef = useRef(null);

  // Debounced search function
  const fetchSuggestions = useCallback(
    debounce(async (query) => {
      if (query.length < 3) {
        setSuggestions([]);
        return;
      }
      try {
        const res = await axios.get(searchUrl, {
          params: { ...params, keyword: query, page: 1, limit: 5 },
        });
        setSuggestions(res.data?.data || []);
        setShowDropdown(true);
      } catch (e) {
        console.error("Autocomplete fetch error", e);
        setSuggestions([]);
      }
    }, 300),
    [searchUrl, JSON.stringify(params)]
  );

  // Close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    const val = e.target.value;
    onChange(val); // Update parent state immediately
    fetchSuggestions(val);
  };

  const handleSelect = (item) => {
    onSelect(item);
    setShowDropdown(false);
    setSuggestions([]);
  };

  return (
    <div className="position-relative w-100" ref={containerRef}>
      <Input
        {...rest}
        value={value}
        placeholder={placeholder}
        onChange={handleInputChange}
        onFocus={() => value.length >= 3 && setShowDropdown(true)}
      />
      <UserSuggestionsDropdown
        visible={showDropdown && suggestions.length > 0}
        suggestions={suggestions}
        onSelect={handleSelect}
      />
    </div>
  );
};

export default AutocompleteInput;